export var LogShippingTokenFields;
(function (LogShippingTokenFields) {
    LogShippingTokenFields["CreatedAt"] = "createdAt";
    LogShippingTokenFields["Token"] = "token";
    LogShippingTokenFields["Enabled"] = "enabled";
    LogShippingTokenFields["Name"] = "name";
})(LogShippingTokenFields || (LogShippingTokenFields = {}));
export var LogShippingTokensSubject;
(function (LogShippingTokensSubject) {
    LogShippingTokensSubject["Table"] = "log-shipping-tokens-table";
    LogShippingTokensSubject["Toggle"] = "log-shipping-tokens-toggle-";
    LogShippingTokensSubject["Created"] = "log-shipping-token-created";
    LogShippingTokensSubject["Removed"] = "log-shipping-token-removed";
    LogShippingTokensSubject["Updated"] = "log-shipping-token-updated";
})(LogShippingTokensSubject || (LogShippingTokensSubject = {}));
export var DataShippingTokensSubject;
(function (DataShippingTokensSubject) {
    DataShippingTokensSubject["ProductSelector"] = "products-selector";
    DataShippingTokensSubject["LoadingView"] = "data-shipping-loading-view";
    DataShippingTokensSubject["RegionCode"] = "region-code";
})(DataShippingTokensSubject || (DataShippingTokensSubject = {}));
export var MetricsShippingTokensSubject;
(function (MetricsShippingTokensSubject) {
    MetricsShippingTokensSubject["Table"] = "metrics-shipping-tokens-table";
})(MetricsShippingTokensSubject || (MetricsShippingTokensSubject = {}));
export var TracingShippingTokensSubject;
(function (TracingShippingTokensSubject) {
    TracingShippingTokensSubject["Table"] = "tracing-shipping-tokens-table";
})(TracingShippingTokensSubject || (TracingShippingTokensSubject = {}));
//# sourceMappingURL=data-shipping-tokens.enum.js.map